/**
 * Returns true only for local dev, QA builds (vite --mode qa), or localhost;
 * false for uat/production builds. Gates non-prod-only UI (e.g. the Auth0
 * email/password login button). The UI gate is UX only — the Auth0 tenant
 * separation is the security boundary.
 */
export const isNonProdEnv = (
  mode: string = import.meta.env.MODE,
  hostname: string = window.location.hostname,
): boolean =>
  mode === 'development' ||
  mode === 'qa' ||
  hostname === 'localhost' ||
  hostname === '127.0.0.1';
